var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionRouteVia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2c1.306 0 2.414.835 2.826 2H17a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-2.174a2.998 2.998 0 0 1-5.652 0H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3v-3l4 4-4 4v-3H7a3 3 0 0 1-3-3v-4a3 3 0 0 1 3-3h2.174a2.998 2.998 0 0 1 5.652 0H17a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9.826A2.999 2.999 0 0 1 4 5a3 3 0 0 1 3-3Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionRouteVia);
export default __webpack_public_path__ + "static/media/ic_action_route_via.9abe025f46a9ce8e9fe0372fc6def11d.svg";
export { ForwardRef as ReactComponent };